import { cva } from "class-variance-authority";

export const unavailablePageIconVariants = cva(
  "size-12 rounded-full flex items-center justify-center",
  {
    variants: {
      variant: {
        unfinished: "bg-muted/20 text-muted-foreground",
        integrationDisabled: "bg-muted/20 text-muted-foreground",
        error: "bg-destructive/10 text-destructive",
        notFound: "bg-muted/20 text-muted-foreground",
      },
    },
    defaultVariants: {
      variant: "unfinished",
    },
  }
);

export const unavailablePageTitleVariants = cva(
  "font-medium text-foreground text-center max-w-md outline-none",
  {
    variants: {
      variant: {
        unfinished: "text-base",
        integrationDisabled: "text-base",
        error: "text-base",
        notFound: "text-base",
      },
    },
    defaultVariants: {
      variant: "unfinished",
    },
  }
);
